module.exports = __webpack_public_path__ + "static/media/icon-pdf.47465c59.svg";